/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom";
import "./app/Utils/Scripts/mixPanel";
import "./index.scss";
import "./app/Utils/utils";
import MainApp from "./app/MainApp";
import Shell from "./app/Shell";
import Utils from "./app/Utils/utils";

Utils.checkAddNonceAndCspTag();

const urlParams = new URLSearchParams(window.location.search);
// The LinkedIn connect popup lands back on /connect/li/callback. Booting the
// Shell there renders the whole app (header, rail, dashboard) inside the popup,
// so render the bare app: just the callback page.
const isOAuthPopupCallback = window.location.pathname.startsWith("/connect/li/callback");
const isAppView = urlParams.get("view") === "app" || isOAuthPopupCallback;

ReactDOM.render(
  isAppView ? <MainApp /> : <Shell />,
  document.getElementById("root")
);
